export const getOststeiermarkData = () => ({
  name: "Oststeiermark",
  region: "Steiermark",
  country: "Autriche",
  description: "Oststeiermark est une sous-région viticole orientale de Steiermark, avec des vignobles établis produisant des vins aromatiques. Cette région bénéficie d'un climat continental avec des microclimats, créant des conditions favorables pour des vins expressifs.",
  type: "subregion",
  area: "400 ha",
  production: "0.02 million hectolitres",
  climate: "Climat continental avec microclimats, étés modérés et hivers froids",
  soil: "Sols granitiques, calcaires, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental avec microclimats, étés modérés et hivers froids",
    soil: "Sols granitiques, calcaires, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs aromatiques et expressifs, avec une acidité vive",
    red: "Vins rouges légers et fruités, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Oststeiermark remonte à l'époque romaine. La région a développé une réputation pour ses vins aromatiques, notamment les vins blancs. Aujourd'hui, Oststeiermark est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Cuisine autrichienne traditionnelle, poissons, fromages frais, plats locaux",
  grapeVarieties: [
    {
      name: "Welschriesling",
      percentage: "40%",
      description: "Cépage blanc principal, produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Muscat",
      percentage: "25%",
      description: "Cépage blanc produisant des vins aromatiques et floraux",
      characteristics: "Aromatique, floral, notes musquées",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Sauvignon Blanc",
      percentage: "20%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Chardonnay",
      percentage: "10%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant des cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Oststeiermark", x: 15.7, y: 47.2, color: "#8a4a8a", size: 2 }
  ]
}); 